import RewardsRegulationPage from 'screens/Contract/RewardsRegulation/RewardsRegulation';

export default RewardsRegulationPage;
